// dependencies
import React from "react";

// components
import { Divider } from "../../../../../../../../../components/Divider";
import GoalListEntry from "./GoalListEntry";

// services
import { Goal } from "../../../../../../../../../api/services";

// styles
import css from "./GoalList.module.scss";

type GoalListProps = {
	goals: Goal[];
};

const GoalList = (props: GoalListProps) => {
	return (
		<div className={css.goalList}>
			{props?.goals?.map((goal, index) => {
				const shouldHaveDivider = index !== props.goals.length - 1;
				return (
					<div key={goal._id} className={css.goalListItemContainer}>
						<GoalListEntry goal={goal} />
						{shouldHaveDivider && <Divider />}
					</div>
				);
			})}
		</div>
	);
};

export default GoalList;
